import React, {  useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { useData } from '../context/DataProvider';
import Fire from '../components/Icon/Fire';
import ArrowRight from '../components/Icon/ArrowRight';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Loader';
import RisingFast from '../components/Icon/RisingFast';
import Emerging from '../components/Icon/Emerging';
import Steady from '../components/Icon/Steady';
import Gaining from '../components/Icon/Gaining';
import Emerging2 from '../components/Icon/Emerging2';
import SearchIcon from '../components/Icon/SearchIcon';
import DropdownIcon from '../components/Icon/DropdownIcon';
import Heart from '../components/Icon/Heart';
export const tagColors = {
  green: { bg: '#E7FFC6', text: '#2E5100' },   
  amber: { bg: '#FFF0CB', text: '#8A5A00' }, 
  blue:  { bg: '#C8E4FF', text: '#1D5FA3' }, 
  purple:{ bg: '#E4CDFF', text: '#1D003E' }, 
};

export const getDiscoveryTags = (trend) => {
  
  const pg = trend?.trend_metrics?.percentage_growth;
  if (typeof pg !== 'number') return [];

  const tags = [];
  if (pg > 100) {
    tags.push({ key: 'acceleration', label: '2x growth this quarter', color: 'green' });
  }
  if (pg < -20) {
    tags.push({ key: 'slowdown', label: 'Slowing this quarter', color: 'amber' });
  }
 
  return tags.slice(0, 2);
};
const Trends = () => {
  const { data} = useData();
  
  const navigate  = useNavigate();
  
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedBrands, setSelectedBrands] = useState('');
  const [searchTerm, setSearchTerm] = useState("");
      const [selectedSort, setSelectedSort] = useState('');
      
      
      const filtersRef = useRef();
      const order = ['Most Active', 'Rising Fast', 'Gaining Momentum', 'Emerging','Established', 'Steady','-'];
      useEffect(() => {
        const handleClickOutside = (e) => {
          if (filtersRef.current && !filtersRef.current.contains(e.target)) {
            setOpenDropdown(null);
          }
        };
      
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);
      
  const orderedTrends = useMemo(() => {
  const classificationCounts = {};
  
  
  const savedList = Array.isArray(data?.savedTrends?.savedTrendIds)
    ? data.savedTrends.savedTrendIds
    : Array.isArray(data?.savedTrends)
    ? data.savedTrends
    : [];

  return [...(data?.trends?.trends || [])]
    .sort((a, b) => {
      
      const isASaved = savedList.includes(String(a.trend_id));
      const isBSaved = savedList.includes(String(b.trend_id));

      
      if (isASaved && !isBSaved) return -1;
      if (!isASaved && isBSaved) return 1;

      
      return order.indexOf(a.trend_classification) - order.indexOf(b.trend_classification);
    })
    .map((trend) => {
      const cls = trend.trend_classification;
      classificationCounts[cls] = (classificationCounts[cls] || 0) + 1;
      return {
        ...trend,
        categoryRank: classificationCounts[cls],
        colorIndex: order.indexOf(cls),
      };
    });
}, [data]);
  const toggleBrandSelection = (brand) => {
    
    setSelectedBrands(brand);
    setOpenDropdown(null); 
  };
  const dropdownContainerRef = useRef(null);
    const renderMultiSelectDropdown2 = (
    isOpen, 
    setIsOpen, 
    selectedOptions, 
    options, 
    toggleSelection, 
    placeholder
  ) => (
    <DropdownWrapper style={{width:245,padding:0}}>
      <DropdownInput 
         
       onClick={() =>
  setOpenDropdown(openDropdown === placeholder ? null : placeholder)
}

      >
        
          <div style={{gap:8,flexDirection:'row',display:'flex'}}><SelectedTxt style={{color:'#20232799'}}>{placeholder}</SelectedTxt> <SelectedTxt> {selectedOptions?selectedOptions :'-'}</SelectedTxt></div>
        <DropdownIcon />
      </DropdownInput>
      <OptionsList isOpen={openDropdown === placeholder}>
        {options.map((option, index) => (
          <DropdownOption
            key={option}
            onClick={() => toggleSelection(option)}
            style={{
              backgroundColor: selectedOptions.includes(option) 
                ? '#E0F2FE' : 'white',
              borderTopLeftRadius: index === 0 ? "8px" : "0",
              borderTopRightRadius: index === 0 ? "8px" : "0",
              borderBottomLeftRadius: index === options.length - 1 ? "8px" : "0",
              borderBottomRightRadius: index === options.length - 1 ? "8px" : "0",
              
            }}
          >
            {option}
          </DropdownOption>
        ))}
      </OptionsList>
    </DropdownWrapper>
  );
  const filteredProducts = orderedTrends?.filter((product) => {
    const lowerSearchTerm = searchTerm?.toLowerCase();
 

  const matchesSearch =
    product.trend_name.toLowerCase().includes(lowerSearchTerm);
  
  
  
  
  const matchesBrands =
    selectedBrands.length === 0 || selectedBrands === '-' ||
    selectedBrands.includes(product.trend_classification)
    
    
    ;
 
  
  return (
    
    
    matchesBrands && matchesSearch 
   
   
  );
});
  return (
    <Container>
        <InnerContainer>
          <Bar ref={filtersRef}>
            <SearchBar>
              <SearchIcon></SearchIcon>
              <SearchInput type="text" placeholder="Search trends..." 
                              value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}/>


            </SearchBar>
           

            
            {/* {renderMultiSelectDropdown2(
                                         openDropdown === "Sort",
              () => setOpenDropdown(openDropdown === "Sort" ? null : "Sort"),
              selectedSort,
              order,
              toggleBrandSelection,
  
                                         "Sort by"
                                       )} */}
{renderMultiSelectDropdown2(
                                         openDropdown === "Filter",
                                         () => setOpenDropdown(openDropdown === "Filter" ? null : "Filter"),
                                         selectedBrands, 
                                         order, 
                                         toggleBrandSelection, 
                                        "Filter by"
                                       )}
          </Bar>
          
     {(!data?.trends) ? (
  <LoaderArea><Loader /></LoaderArea>
) : (
  (() => {
    
    const bgColors = ['linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)','#BDDEFF','#DCFFAD','#EFFFB9','#FFD4D5','#2023271A','#2023271A'];
  

    return filteredProducts.map((trend) => (
      <Block onClick={() => navigate(`/trend`, { state: { trendId: trend.trend_id, classification: trend.trend_classification,
        discoveryTags: getDiscoveryTags(trend),
       } })} key={trend.trend_id}>
        <Block1>
          <Block2>
            
            <Tag bgColor={bgColors[trend.colorIndex]}>
              <TagText>{trend.trend_classification || 'N/A'}</TagText>
            </Tag>
            
            <Title>{trend.trend_name}</Title>
            <Line></Line>
            {trend.trend_classification === 'Most Active' && <Fire/>}
            {trend.trend_classification === 'Rising Fast' && <RisingFast/>}
            {trend.trend_classification === 'Gaining Momentum' && <Gaining/>}
            {trend.trend_classification === 'Emerging' && <Emerging/>}
            {trend.trend_classification === 'Steady' && <Steady/>}
           
     {   getDiscoveryTags(trend).map((tag) => (
    <DiscoveryTagPill key={tag.key} color={tag.color}>
      {tag.label.toUpperCase()}
    </DiscoveryTagPill>
  ))}
  {(data?.savedTrends?.savedTrendIds || []).some((item) => item === trend.trend_id) && <Heart/>}
          </Block2>
          
          <Block3>
            <Block3Text>VIEW TREND</Block3Text>
            <ArrowRight/>
          </Block3>
        </Block1>
      </Block>
    ));
  })()
)}
            

        </InnerContainer>
    </Container>
  );
};

const SelectedTxt = styled.p`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
color:#202327;
margin:0;
`
const Bar = styled.div`
width: 100%;
gap:10px;
display:flex;
`;
const Bar2 = styled.div`
border-radius: 12px;
background: #FFFFFF;
width:245px;
display:flex;
justify-content: space-between;
align-items:center;
padding: 12px;
`
const SearchBar = styled.div`
flex:1;
height: 44px;
border-radius:12px;
padding:12px;
gap:8px;
background: #FFFFFF;
display:flex;
align-items:center;

`
const P1Txt = styled.p`

font-weight: 500;
font-size: 14px;
line-height: 120%;
letter-spacing: 0%;
margin:0;
color:#20232799;

`
const SearchInput = styled.input`
border:none;
outline:none;
width:100%;
font-family: PP Mori;
font-weight: 600;
color:#20232799;
line-height: 120%;
font-size: 14px;
`

const Block3 = styled.div`
outline:none;
border:none;
background:transparent;
cursor :pointer;
height: 16px;
border-radius: 64px;
display:flex;
align-items:center;
gap: 8px;

`

const Block3Text = styled.h1`
font-family: PP Mori;
font-weight: 800;
font-style: ExtraBold;
font-size: 12px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
text-transform: uppercase;
color:#202327;


`
const TagText = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 10px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;

text-transform: uppercase;
color: #202327;

`
const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  padding-right:12px;
  padding-left:12px;

   white-space: normal;        
  word-break: break-word;    
  overflow-wrap: break-word; 

  
`;

const DropdownInput = styled.div`
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  color: #20232799;
  border: 1px solid #d1d1d1;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  align-items: center;
  padding: 12px;
  

gap: 0px;
border-radius: 12px;
display:flex;


  
border:none;
  outline:none;
  &:hover {
    border-color: #000; /* Optional hover effect */
  }
`;

const OptionsList = styled.ul`
  position: absolute;
  
  top: calc(100% + 4px);
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0px ;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 24px rgba(24, 25, 26, 0.1);
  z-index: 10000000;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  
`;

const DropdownOption = styled.li`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #202327;
  cursor: pointer;

  &:hover {
    background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
    
    
  }
`;
const Title = styled.h1`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 18px;
leading-trim: NONE;
line-height: 110.00000000000001%;
letter-spacing: -1%;
`
const Container = styled.div`


gap: 30px;
border: 0px 1px 0px 0px;
opacity: 0px;
padding: 30px;
gap: 30px;
border-right-width: 1px;


`
const InnerContainer = styled.div`
display:flex;
gap:8px;
flex-direction:column;
`
const Block = styled.button`
outline:none;
border:none;
cursor:pointer;
height: 70px;
border-radius: 16px;
padding: 24px;
gap: 24px;
background: #FFFFFF;
box-shadow: 0px 0px 24px 0px #2F323705;



`
const Line = styled.div`
width: 1px;
height: 16px;
background: #20232733;

`
const Block1 = styled.div`

height: 22px;
display:flex;
flex-direction:row;
width:100%;
align-items:center;
justify-content: space-between;


`
const Block2 = styled.div`

height: 22px;
gap: 16px;
display:flex;
align-items:center;
`
const Tag = styled.div`
  height: 22px;
  border-radius: 4px;
  gap: 10px;
  padding-right: 8px;
  padding-left: 8px;
  justify-content: center;
  align-items: center;
  display: flex;

  /* Dynamically use the passed bgColor prop */
  background: ${props => props.bgColor || 'transparent'};
`;
const LoaderArea = styled.div`
width:100%;
height:100%;
align-items:center;
display:flex;
justify-content:center;

`
const DiscoveryTagPill = styled.div`
  padding: 5px 8px;
  border-radius: 6px;
  font-family: PP Mori;
  font-weight: 800;
  font-size: 11px;
  line-height: 120%;
  white-space: nowrap;
  background: ${({ color }) => tagColors[color]?.bg || '#2023271A'};
  color: ${({ color }) => tagColors[color]?.text || '#202327'};
`;
export default Trends;